module.exports = __webpack_public_path__ + "assets/046f077c3fbb3855985f225689d4774b.jpg";